import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-tile',
    templateUrl: './tile.component.html',
    styleUrls: ['./tile.component.scss']
})
export class TileComponent {
    @Input() customDesignTiles: boolean;
    @Input() smallerIcon: boolean;
    @Input() tabindex: number;
    @Input() icon: string;
    @Input() title: string;
    @Input() text: string;
    @Input() disabled: boolean;
    @Input() inDevelopment: boolean;
    @Input() customIcon: string;
    @Input() contentFromTop: boolean;
    @Input() ariaLabel: string;
    @Output() tileClickEvent = new EventEmitter<void>();

    onKeyUp(event): void {
        if (event.key === 'Enter' || event.code === 'Space') {
            this.tileClickEvent.emit();
        }
    }
}
